export default __webpack_public_path__ + "static/media/fullscreen.894e618f.svg";